import { useMemo } from "react";
import { ReadOnlyMemo } from "../ReadonlyRule";
import { useAppSelector } from "redux/hooks";
import { selectConceptCache } from "redux/slices/lensEditor";
import { Tooltip } from "@mui/material";
import { IncludesEntity, LensRule } from "generated/graphql";

type LensPatch = {
  entries: LensRuleEntry[];
};

type LensRuleEntry = {
  Add: LensRule & { query: { IncludesEntity: IncludesEntity } };
};

type LensPatchDisplayProps = {
  patch: string;
};

function LensPatchDisplay({ patch }: LensPatchDisplayProps) {
  const parsedPatch = useMemo(() => {
    if (patch) {
      try {
        return JSON.parse(patch) as LensPatch;
      } catch {
        return undefined;
      }
    }
  }, [patch]);

  const conceptCache = useAppSelector(selectConceptCache);

  return (
    <div className="flex flex-col max-h-96 overflow-y-auto overflow-x-hidden">
      {parsedPatch &&
        parsedPatch.entries.map((entry, idx: number) => {
          const lensRule = entry.Add;
          const entityId = lensRule.query?.IncludesEntity?.entityId;
          const concept = entityId ? conceptCache[entityId] : undefined;

          return (
            <>
              <ReadOnlyMemo
                key={idx}
                rule={lensRule}
                readOnly
                setSelected={() => {}}
                deleteRule={() => {}}
                concept={concept}
              />
              <div className="ml-1 flex max-w-48">
                <Tooltip title={concept?.canonicalName}>
                  <span className="inline-block text-xs text-gray-300 truncate">{concept?.canonicalName}</span>
                </Tooltip>
              </div>
            </>
          );
        })}
    </div>
  );
}

export default LensPatchDisplay;
